export const getFirstPictureInSections = (sections = []) => {
  for (const section of sections) {
    if (section) {
      switch (section.type) {
        case 'HeroSection':
        case 'IntroductionSection':
        case 'FullImageSection':
        case 'ImageSetSection':
          if (section?.pictures[0]?.url) {
            return section?.pictures[0]?.url;
          }
          break;
        default:
          break;
      }
    }
  }
  return null;
};
